import * as React from "react";
const SvgFiBrandsGithub = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-github_svg__a)">
      <path
        fillRule="evenodd"
        d="M12.5.296C5.597.296 0 5.668 0 12.296c0 5.302 3.581 9.8 8.548 11.387.625.11.854-.26.854-.577 0-.286-.011-1.231-.017-2.234-3.477.726-4.211-1.416-4.211-1.416-.569-1.387-1.388-1.756-1.388-1.756-1.134-.745.086-.73.086-.73 1.255.086 1.915 1.238 1.915 1.238 1.115 1.834 2.924 1.304 3.638.997.112-.776.436-1.305.794-1.605-2.776-.303-5.695-1.332-5.695-5.93 0-1.31.489-2.381 1.289-3.221-.13-.303-.559-1.523.12-3.176 0 0 1.05-.322 3.439 1.23a12.5 12.5 0 0 1 3.128-.404c1.063.005 2.132.138 3.131.404 2.386-1.553 3.435-1.23 3.435-1.23.68 1.653.252 2.873.123 3.176a4.54 4.54 0 0 1 1.286 3.22c0 4.61-2.924 5.625-5.707 5.922.448.372.848 1.103.848 2.222 0 1.606-.015 2.898-.015 3.293 0 .319.225.694.858.576 4.965-1.59 8.542-6.085 8.542-11.385C25 5.669 19.403.296 12.5.296"
        clipRule="evenodd"
      />
      <path d="M4.734 17.526c-.027.06-.125.078-.214.037-.09-.039-.142-.12-.113-.18.027-.06.125-.078.216-.037.09.038.143.12.111.18M5.24 18.068c-.059.053-.176.028-.255-.055-.082-.084-.097-.196-.036-.249s.174-.028.256.056c.082.083.098.194.036.248M5.733 18.759c-.077.051-.202.003-.279-.103-.077-.107-.077-.235.002-.286.077-.051.201-.005.28.101.076.108.076.236-.003.288M6.408 19.427c-.068.073-.214.053-.32-.046-.11-.097-.14-.234-.071-.307s.216-.052.324.046c.108.097.14.235.067.307M7.34 19.814c-.03.094-.17.137-.312.097-.141-.041-.234-.151-.205-.246s.17-.14.314-.096c.14.04.233.15.204.245M8.363 19.886c.004.099-.116.181-.265.183s-.271-.077-.272-.174c0-.1.118-.181.267-.184s.27.077.27.175M9.316 19.731c.017.096-.086.196-.234.222-.144.026-.279-.034-.298-.13-.017-.099.088-.198.233-.224.147-.025.28.033.299.132" />
    </g>
    <defs>
      <clipPath id="fi-brands-github_svg__a">
        <path fill="#fff" d="M0 0h25v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsGithub;
